// @flow

import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import classNames from 'classnames';

// Components
import styles from 'components/SimpleModal.scss';

/**
 * Modal React component.
 * @return {JSX | null} - react component render.
 */
const SimpleModal = props => {
  const { extendStyle, isModalOpen, children } = props;
  const { classModal, classModalOpen, classModalContent } = styles;

  if (!isModalOpen) {
    if (typeof window !== 'undefined') {
      document.body.style.overflow = 'visible';
    }

    return null;
  }

  if (typeof window !== 'undefined') {
    document.body.style.overflow = 'hidden';
  }

  return (
    <div className={classNames(classModal, extendStyle, classModalOpen)}>
      <div className={classModalContent}>{children}</div>
    </div>
  );
};

SimpleModal.propTypes = {
  isModalOpen: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

export default SimpleModal;



// WEBPACK FOOTER //
// ./src/Common/SimpleModal/index.js